// bullet \u25CF dash \u2504 line \u2501
export const getIndicatorShapes = (theme) => {
    return {
        bar: theme.dataVisualization.toolTipsAndLegends.legendSymbol === "Circle" ? "\u25CF" : "\u25A0",
        line: "\u2501",
        "dashed-line": "\u2504",
    };
};
